import { normalizarLinksConteudoNoHtml, normalizarUrlConteudo } from '@/utils/linksPortalAntigo'

const ICONES = {
    1: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
    2: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><path d="M15 3h6v6"/><path d="M10 14L21 3"/></svg>',
    3: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>',
    4: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>'
}
const BALANCA = '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v18"/><path d="M5 7h14"/><path d="M5 7l-2.5 6a3.5 3.5 0 0 0 5 0z"/><path d="M19 7l2.5 6a3.5 3.5 0 0 1-5 0z"/></svg>'
const SETA = '<svg class="seta" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>'
const ICONE_EXTERNO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><path d="M15 3h6v6"/><path d="M10 14L21 3"/></svg>'
const ICONE_DOWNLOAD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M7 10l5 5 5-5"/><path d="M12 15V3"/></svg>'

export function tipoDaAnotacao(idTipoAnotacao, lstTipoAnotacao) {
    const tipo = (lstTipoAnotacao || []).find(x => x.idTipoAnotacao == idTipoAnotacao)
    return tipo ? tipo.cdTipoAnotacao : 1
}

export function htmlGatilhoAnotacao(anotacao, lstTipoAnotacao) {
    const cdTipo = tipoDaAnotacao(anotacao.idTipoAnotacao, lstTipoAnotacao)
    const reg = anotacao.flRegulamentacao === 'Sim'
    const rotulo = reg ? 'Regulamentação'
        : cdTipo === 4 ? 'Anotação em vídeo'
        : cdTipo === 3 ? 'Anotação com arquivo'
        : 'Anotação'
    const icone = reg ? BALANCA : (ICONES[cdTipo] || ICONES[1])
    const classes = 'ver_anotacao' + (reg ? ' legislacao_anotacao_regulamentacao' : '')

    return `<a class="${classes}" role="button" tabindex="0"
             data-id="${anotacao.idLegislacaoAnotacao}" data-tipo="${cdTipo}">
            ${icone}${rotulo}${SETA}
          </a>
          <span class="legislacao_anotacao${reg ? ' legislacao_anotacao_regulamentacao' : ''}"
                id="LegislacaoAnotacao-${anotacao.idLegislacaoAnotacao}"></span>`
}

function dominio(url) {
    try { return new URL(url).hostname.replace(/^www\./, '') } catch { return url || '' }
}

function nomeArquivo(url) {
    if (!url) return 'arquivo'
    const partes = url.split('/')
    return partes[partes.length - 1] || 'arquivo'
}

function extensao(nome) {
    const idx = nome.lastIndexOf('.')
    return idx > 0 ? nome.substring(idx + 1).toUpperCase() : 'ARQ'
}

function descricaoDoFormato(nome) {
    const ext = extensao(nome)
    const map = { PDF: 'Documento PDF', DOC: 'Documento Word', DOCX: 'Documento Word', XLS: 'Planilha', XLSX: 'Planilha', PPT: 'Apresentação', PPTX: 'Apresentação', ZIP: 'Arquivo compactado' }
    return map[ext] || `Arquivo ${ext}`
}

function playerDoVideo(a) {
    if (a.tpExibicaoVideo == 'Local') {
        return `<video allowfullscreen controls="controls" onkeydown="return false" oncontextmenu="return false">
            <source src="${a.urlVideo}" type="video/mp4">
            <source src="${a.urlVideo}" type="video/webm">
        </video>`
    }
    if (a.tpExibicaoVideo == 'YouTube') {
        let src = (a.urlVideo || '').replace('https://www.youtube.com/watch?v=', '')
        src = src.replace('https://youtu.be/', '')
        if (src.indexOf('&') > 0) src = src.substring(0, src.indexOf('&'))
        return `<iframe src="https://www.youtube.com/embed/${src}?controls=1&disablekb=1&fs=0&mute=1&modestbranding=1&iv_load_policy=3&showinfo=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
    }
    const src = (a.urlVideo || '').replace('https://vimeo.com/', '')
    return `<iframe src="https://player.vimeo.com/video/${src}" allowfullscreen></iframe>`
}

export function htmlPainelAnotacao(a, lstTipoAnotacao) {
    const reg = a.flRegulamentacao === 'Sim'
    const cd = tipoDaAnotacao(a.idTipoAnotacao, lstTipoAnotacao)
    let html = `<span class="rotulo">${reg ? 'Norma regulamentadora' : 'Anotação do editor'}</span>`
    html += `<span class="titulo">${a.dsTitulo || ''}</span>`

    if (cd === 1) {
        html += `<div class="descricao">${normalizarLinksConteudoNoHtml(a.dsDescricao || '')}</div>`
    }

    if (cd === 2) {
        const urlLink = normalizarUrlConteudo(a.urlLink) || a.urlLink
        html += `<a class="link" href="${urlLink}" target="_blank" rel="noopener">
               ${ICONE_EXTERNO}Abrir a norma
               <span class="host">${dominio(urlLink)}</span>
             </a>`
    }

    if (cd === 3) {
        const nome = nomeArquivo(a.urlUpload)
        html += `<button type="button" id="downloadAnotacao"
                     class="anotacao-arquivo anotacao_oculta_imprimir"
                     data-url="${a.urlUpload}">
               <span class="fmt">${extensao(nome)}</span>
               <span>
                 <span id="downloadAnotacaoText">${nome}</span>
                 <span class="peso">${descricaoDoFormato(nome)}</span>
               </span>
               <span class="baixar">${ICONE_DOWNLOAD}Baixar</span>
             </button>
             <span class="txt-link">Arquivo: ${nome}</span>`
    }

    if (cd === 4) {
        html += `<div class="anotacao-video anotacao_oculta_imprimir">${playerDoVideo(a)}</div>
             <span class="txt-link">Vídeo: ${a.urlVideo}</span>`
    }

    return html
}

export function cssImpressaoLei() {
    return `<style>
        body { font-family: Georgia, "Times New Roman", serif; color: #232330; padding: 24px; line-height: 1.6; }
        h3 { font-size: 18pt; margin: 0 0 8px; }
        .subtituloLei { color: #5F5F6C; font-size: 11pt; font-style: italic; margin: 0 0 16px; }
        .aparato-resumo, .ver_anotacao, .modal-footer { display: none !important; }
        .legislacao_anotacao { display: block !important; margin: 10px 0 18px; padding: 4px 0 4px 14px; border: 0; border-left: 2px solid #999 !important; background: #fff !important; }
        .rotulo { display: block; font-size: 8pt; letter-spacing: .12em; text-transform: uppercase; font-weight: 700; margin-bottom: 4px; }
        .titulo { display: block; font-weight: 700; margin-bottom: 6px; }
        .anotacao_oculta_imprimir { display: none !important; }
        .txt-link { display: block !important; font-size: 10pt; word-break: break-all; }
    </style>`
}
